// /opt/isp_erp/frontend/src/api/warehouse.api.js
import api from './axios';

export const warehouseAPI = {
  // Estadísticas
  getEstadisticas: () => api.get('/warehouse/estadisticas'),
  
  // Equipos
  buscarEquipo: (sn) => api.get(`/warehouse/equipos/buscar/${sn}`),
  getHistorialEquipo: (sn) => api.get(`/warehouse/equipos/${sn}/historial`),
  crearEquipo: (data) => api.post('/warehouse/equipos', data),
  listarEquipos: (params) => api.get('/warehouse/equipos', { params }), // NUEVO: para listar todos los equipos
  listarEquiposPaginado: (params) => api.get('/warehouse/equipos/paginado', { params }),
  listarMaterialesPaginado: (params) => api.get('/warehouse/materiales/paginado', { params }),
  listarMovimientosMaterialesPaginado: (params) => api.get('/warehouse/materiales/movimientos/paginado', { params }),
  getResumenDiario: (params) => api.get('/warehouse/reportes/resumen-diario', { params }),
  descargarResumenDiarioPDF: (params) => api.get('/warehouse/reportes/resumen-diario-pdf', { params, responseType: 'blob' }),
  listarProveedores: (params) => api.get('/warehouse/proveedores', { params }),
  opcionesProveedores: () => api.get('/warehouse/proveedores/opciones'),
  crearProveedor: (data) => api.post('/warehouse/proveedores', data),
  actualizarProveedor: (id, data) => api.put(`/warehouse/proveedores/${id}`, data),
  eliminarProveedor: (id) => api.delete(`/warehouse/proveedores/${id}`),
  listarIngresosMateriales: (params) => api.get('/warehouse/ingresos/materiales', { params }),
  registrarIngresoMaterial: (data) => api.post('/warehouse/ingresos/materiales', data),
  editarIngresoMaterial: (id, data) => api.put(`/warehouse/ingresos/materiales/${id}`, data),
  anularIngresoMaterial: (id, data) => api.post(`/warehouse/ingresos/materiales/${id}/anular`, data),
  registrarLoteEquipos: (data) => api.post('/warehouse/ingresos/equipos', data),
  listarLotesEquipos: (params) => api.get('/warehouse/ingresos/equipos', { params }),
  equiposDelLote: (id, params) => api.get(`/warehouse/ingresos/equipos/${id}/equipos`, { params }),
  editarLoteEquipos: (id, data) => api.put(`/warehouse/ingresos/equipos/${id}`, data),
  anularLoteEquipos: (id, data) => api.post(`/warehouse/ingresos/equipos/${id}/anular`, data),
  descargarPlantillaEquipos: () => api.get('/warehouse/ingresos/equipos/plantilla', { responseType: 'blob' }),
  descargarIngresosPDF: (params) => api.get('/warehouse/reportes/ingresos-pdf', { params, responseType: 'blob' }),
  candidatosActa: (params) => api.get('/warehouse/actas/candidatos', { params }),
  listarActas: (params) => api.get('/warehouse/actas', { params }),
  crearActa: (data) => api.post('/warehouse/actas', data),
  descargarActaPDF: (id) => api.get(`/warehouse/actas/${id}/pdf`, { responseType: 'blob' }),
  anularActa: (id, data) => api.post(`/warehouse/actas/${id}/anular`, data),
  stockTecnicoPaginado: (id, params) => api.get(`/warehouse/materiales/stock-tecnico/${id}/paginado`, { params }),
  alertasStockPaginado: (params) => api.get('/warehouse/alertas/stock-minimo/paginado', { params }),
  devolverMaterialBodega: (params) => api.post('/warehouse/materiales/devolver-bodega', null, { params }),
  descargarAsignacionPDF: (params) => api.get('/warehouse/reportes/asignacion-tecnico-pdf', { params, responseType: 'blob' }),
  importarEquiposExcel: (formData) => api.post('/warehouse/ingresos/equipos/importar', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  
  // Movimientos
  despacharEquipo: (data) => api.post('/warehouse/movimientos/despacho', data),
  instalarEquipo: (sn, customerId, installationId, ticketId) =>
    api.post('/warehouse/movimientos/instalacion', null, {
      params: { sn, customer_id: customerId, installation_id: installationId, ticket_id: ticketId }
    }),
  retirarEquipo: (sn, ticketId, tecnicoId, observaciones) =>
    api.post('/warehouse/movimientos/retiro', null, {
      params: { sn, ticket_id: ticketId, tecnico_id: tecnicoId, observaciones }
    }),
  recepcionEquipo: (data) => api.post('/warehouse/movimientos/recepcion', data),
  transferirEquipo: (data) => api.post('/warehouse/movimientos/transferencia', data),

   // Reingresar a RMA
  reingresarEquipoRMA: async (sn, observaciones) => {
    const response = await api.post('/warehouse/movimientos/reingreso-rma', {
      sn: sn,
      observaciones: observaciones || 'Reingreso desde RMA a inventario'
    });
    return response;
  },

  // ✅ NUEVO: Dar de baja definitiva (equipo irrecuperable)
  darDeBajaDefinitiva: async (sn, motivo) => {
    const response = await api.post('/warehouse/movimientos/baja-definitiva', {
      sn: sn,
      motivo: motivo
    });
    return response;
  },

  // Eliminar equipo
  eliminarEquipo: (sn) => api.delete(`/warehouse/equipos/${sn}`),

  // Eliminar material del catálogo
  eliminarMaterial: (materialId) => api.delete(`/warehouse/materiales/${materialId}`),
  
  // Consultas
  getPendientesRetiro: () => api.get('/warehouse/pendientes/retiro'),
  getMovimientos: (params) => api.get('/warehouse/movimientos', { params }), // NUEVO: para listar historial de movimientos
  getEquiposRMA: () => api.get('/warehouse/equipos/rma') // NUEVO: para listar equipos en RMA
};
